import { Box, Flex, Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import browserWarning from '../../../assets/image/browser-warning.svg';
const PageNotFound = () => {
  const { t } = useTranslation();
  const FlexItem = (props: any) => (
    <Box display="inline" verticalAlign="middle" fontSize="14px" {...props} />
  );
  return (
    <>
      <Flex pt="192px">
        <FlexItem flex="auto">{}</FlexItem>
        <FlexItem flex="auto" textAlign="center">
          <img src={browserWarning} />
          <Text color="#FFFFFFF" mt={60}>
            {t('common.notFound.warning')}
          </Text>
        </FlexItem>
        <FlexItem flex="auto">{}</FlexItem>
      </Flex>
    </>
  );
};
export default PageNotFound;
